import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import formatErrorMessage from 'core/format_error_message';
const containerCss = "cdc8q1j";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const extractMessage = (message, enforceEndingPeriod) => {
  if (!message) return null;

  // React node
  if (Array.isArray(message) && message.some(part => part.$$typeof)) {
    return message;
  }
  const extractedMessage = Array.isArray(message) ? message[0] : message;
  return extractedMessage ? formatErrorMessage(extractedMessage, enforceEndingPeriod) : null;
};
const ErrorMessage = ({
  message = null,
  enforceEndingPeriod = true,
  ...props
}) => {
  const extractedMessage = extractMessage(message, enforceEndingPeriod);
  return <Container {...props} data-component="error-message">
      {extractedMessage}
    </Container>;
};
ErrorMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  enforceEndingPeriod: PropTypes.bool
};
export default ErrorMessage;

require("./error_message.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./error_message.js");